import { Layout, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { CloseIcon, MapsIcon, NoImageLogo, SuccessLogo } from "../../asset";
import PrimaryButton from "../button/PrimaryButton";
import MapsFullScreen from "../maps/MapsFullScreen";
import Geocode from "react-geocode";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { GROLOG_ORDER_URL } from "../../constant/apiConstant";
import axios from "axios";
import CustomDivider from "../divider/CustomDivider";
const ModalDetail = (props) => {
  const { t } = useTranslation();
  const [loc, setLoc] = useState();
  const [detail, setDetail] = useState([]);
  console.log("props", props);

  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const api = GROLOG_ORDER_URL;
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: token };
    const request = { url, method, headers, params };
    return axios(request);
  };
  const fetchData = async () => {
    // if(props.tripId !== 0){
    //   let res = await doGet(`/all-trip/trip-route/${props.tripId}?${param}`, token);
    // setDetail(res?.data?.payload?.data);
    // }else{
    //   let res = await doGet(`/order/${props.orderId}?${param}`, token);
    //   setDetail(res?.data?.payload?.data);
    // }
    // let res = await doGet(`/all-trip/trip-route/${3}?${param}`, token);
  };
  useEffect(() => {
    fetchData();
  }, []);

  console.log("props", props?.detail);
  return (
    <>
      <div
        id="modal-info"
        className={`w-full h-full bg-gray-300 bg-opacity-50 top-0 left-0
     fixed justify-center ${props.show ? "" : "hidden"} `}
        // onClick={() => props.onClose()}
        style={{ zIndex: 100000000000 }}
      >
        <div className="flex flex-col justify-center items-center">
          <div className="mt-6 flex justify-center"></div>
          <div
            className="mt-6 flex justify-end ml-[50%] mr-2 cursor-pointer"
            onClick={() => props.onClose()}
          ></div>
          <div></div>
          <div className="w-[1000px] border-2 shadow-[0px 4px 4px rgba(0, 0, 0, 0.25)] rounded-md bg-white-100 border-gray-200 h-[707px] mt-2 cursor-pointer">
            <div
              className="mt-6 flex justify-end ml-[50%] mr-2 cursor-pointer"
              onClick={() => props.onClose()}
            >
              <img className="h-6" src={CloseIcon} alt="map" />
            </div>
            <div
              className=""
              style={{
                overflowY: "auto",
                height: "660px",
                overflowX: "hidden",
              }}
            >
              <div className="flex ml-2">
                <div>
                  <div className="flex">
                    <div className="gap-[40px] mb-[24px]">
                      {/* <div className="w-[500px] mb-[24px]">
                        <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                          {t("Order Detail")}
                        </h3>
                      </div> */}
        <CustomDivider name={"Order Detail"} />

                      <div className="flex">
                        {/* //one */}
                        <div className="gap-[40px] mb-[24px]">
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Company Profile ID")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.company_profile_id
                                ? props?.detail?.company_profile_id
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Customer Profile ID")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.customer_profile_id}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Delivery Type")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.delivery_type}
                            </h4>
                          </div>
                        </div>
                        {/* line two */}
                        <div className="gap-[40px] mb-[24px]">
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("First Name")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.first_name
                                ? props?.detail?.first_name
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Last Name")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.last_name
                                ? props?.detail?.last_name
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Email")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.email
                                ? props?.detail?.email
                                : "-"}
                            </h4>
                          </div>
                        </div>
                        {/* line three */}
                        <div className="gap-[40px] mb-[24px]">
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Phone")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.customer_phone
                                ? props?.detail?.customer_phone
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Fax")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.customer_fax
                                ? props?.detail?.customer_fax
                                : "-"}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex mt-[-30px] ml-2">
                <div>
                  <div className="flex">
                    <div className="gap-[40px] mb-[24px]">
                      {/* <div className="w-[500px] mb-[24px]"> */}
                        {/* <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                          {t("Address Detail")}
                        </h3> */}
        <CustomDivider name={"Address Detail"} />
                      {/* </div> */}

                      <div className="flex">
                        {/* //one */}
                        <div className="gap-[40px] mb-[24px]">
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Country")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.country ? props?.detail?.country : props?.detail?.country_name
                                ? props?.detail?.country_name
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Island")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.island ? props?.detail?.island :props?.detail?.island_name
                                ? props?.detail?.island_name
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Province")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.province ? props?.detail?.province :props?.detail?.province_name
                                ? props?.detail?.province_name
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("District")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.district ? props?.detail?.district : props?.detail?.district_name
                                ? props?.detail?.district_name
                                : "-"}
                            </h4>
                          </div>
                        </div>
                        {/* line two */}
                        <div className="gap-[40px] mb-[24px]">
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Sub District")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.sub_district ? props?.detail?.sub_district :props?.detail?.sub_district_name
                                ? props?.detail?.sub_district_name
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Urban Village")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.urban_village ? props?.detail?.urban_village :props?.detail?.urban_village_name
                                ? props?.detail?.urban_village_name
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Address")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.address
                                ? props?.detail?.address
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Neighbourhood")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.neighbourhood
                                ? props?.detail?.neighbourhood
                                : "-"}
                            </h4>
                          </div>
                        </div>
                        {/* line three */}
                        <div className="gap-[40px] mb-[24px]">
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Hamlet")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.hamlet
                                ? props?.detail?.hamlet
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Postal Code")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.postal_code
                                ? props?.detail?.postal_code
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Latitude")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.latitude
                                ? props?.detail?.latitude
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Longitude")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.longitude
                                ? props?.detail?.longitude
                                : "-"}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex mt-[-30px] ml-2">
                <div>
                  <div className="flex">
                    <div className="gap-[40px] mb-[24px]">
                      <div className="w-[500px] mb-[24px]">
                        <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                          {t("Routes Detail")}
                        </h3>
                      </div>
                      <div className="flex">
                        {/* //one */}
                        <div className="gap-[40px] mb-[24px]">
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Receipt Name")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.receipt_name
                                ? props?.detail?.receipt_name
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Previous Trip")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.previous_trip
                                ? props?.detail?.previous_trip
                                : ""}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Trip Route Sequence")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.trip_route_sequence
                                ? props?.detail?.trip_route_sequence
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Trip Route Cost")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.trip_route_cost
                                ? props?.detail?.trip_route_cost
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px] flex">
                            <div>
                              <label className="font-roboto text-[14px] text-[#000000]">
                                {t("Receive Image")}
                              </label>
                              <div className="aspect-square border-[2px] w-28 text-[#424242] border-gray-100 p-6 rounded-xl">
                                <img
                                  className="aspect-square"
                                  src={
                                    props?.detail?.receive_image_url
                                      ? props?.detail?.receive_image_url
                                      : NoImageLogo
                                  }
                                  alt="photoh"
                                />
                              </div>
                            </div>
                            <div className="ml-2">
                              <label className="font-roboto text-[14px] text-[#000000]">
                                {t("Signature Image")}
                              </label>
                              <div className="aspect-square border-[2px] w-28 text-[#424242] border-gray-100 p-6 rounded-xl">
                                <img
                                  className="aspect-square"
                                  src={
                                    props?.detail?.signature_image_url
                                      ? props?.detail?.signature_image_url
                                      : NoImageLogo
                                  }
                                  alt="photoh"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* line two */}
                        <div className="gap-[40px] mb-[24px]">
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Routes Distance")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.route_distance
                                ? props?.detail?.route_distance
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Routes Estimation Time")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.route_estimation_time
                                ? props?.detail?.route_estimation_time
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Routes Status")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.route_status
                                ? props?.detail?.route_status
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Trip Routes Start Delivery")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.trip_route_start_delivery
                                ? props?.detail?.trip_route_start_delivery
                                : "-"}
                            </h4>
                          </div>
                        </div>
                        {/* line three */}
                        <div className="gap-[40px] mb-[24px]">
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Trip Routes Finished Delivery")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.trip_route_finished_delivery
                                ? props?.detail?.trip_route_finished_delivery
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Trip Route Start Pickup")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.trip_route_start_pickup
                                ? props?.detail?.trip_route_start_pickup
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Trip Route Finished Pickup")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.trip_route_finished_pickup
                                ? props?.detail?.trip_route_finished_pickup
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Waiting Time")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {props?.detail?.waiting_time
                                ? props?.detail?.waiting_time
                                : "-"}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* </div> */}
          {/* <img className="mt-20 w-[500px]" src={props.photo ? props.photo : NoImageLogo} alt="popup"/> */}
        </div>
      </div>
      {/* </div> */}
      {/* </Modal> */}
    </>
  );
};
export default ModalDetail;
